module.exports = __webpack_public_path__ + "img/qiyeweixin.7010268f.png";